import { lazy } from 'react';

const TeamMemberRoutes = [
  {
    path: 'content/team-members',
    component: lazy(() => import('views/team-members')),
  },
  {
    path: 'content/team-members/add',
    component: lazy(() => import('views/team-members/team-member-add')),
  },
  {
    path: 'content/team-members/:id',
    component: lazy(() => import('views/team-members/team-member-edit')),
  },
];

export default TeamMemberRoutes;
